import React, { useContext } from 'react';
import ManageRoutes from 'components/manageRoutes/ManageRoutes';
import AppContext from 'AppContext';
import { NewsletterAppMode } from 'enums/newsletterAppModes';
import List from '../list/List';
import Actions from '../actions/Actions';
import Latest from '../latest/Latest';
import ViewerRoutes from '../viewer/ViewerRoutes';

const MODE_LIST: NewsletterAppMode = NewsletterAppMode.ListMode;
const MODE_ACTIONS: NewsletterAppMode = NewsletterAppMode.ActionsMode;
const MODE_LATEST: NewsletterAppMode = NewsletterAppMode.LatestMode;
const MODE_VIEWER: NewsletterAppMode = NewsletterAppMode.ViewerMode;
const MODE_MANAGE: NewsletterAppMode = NewsletterAppMode.ManageMode;
const MODE_TEST: NewsletterAppMode = NewsletterAppMode.TestMode;

interface Props {
  mode: string;
}

const Newsletter = ({ mode }: Props) => {
  const { actionsShowSubscribe, actionsShowEdit, actionsShowUnsubscribe, actionsId } =
    useContext(AppContext);

  switch (mode) {
    case MODE_LIST: {
      return <List />;
    }
    case MODE_ACTIONS: {
      return (
        <Actions
          showSubscribe={actionsShowSubscribe}
          showEdit={actionsShowEdit}
          showUnsubscribe={actionsShowUnsubscribe}
          id={actionsId}
        />
      );
    }
    case MODE_LATEST: {
      return <Latest />;
    }
    case MODE_VIEWER: {
      return <ViewerRoutes />;
    }
    case MODE_MANAGE: {
      return <ManageRoutes />;
    }

    case MODE_TEST: {
      return (
        <>
          <h1>=============== TEST MODE ===============</h1>
          <br />
          <h2>---- TEST LIST ----</h2>
          <br />
          <List />
          <br />
          <h2>---- TEST LATEST ----</h2>
          <br />
          <Latest />
          <br />
          {/* <h2>---- TEST VIEWER ---- </h2>
          <br />
          <Viewer />
          <br /> */}
          <h2>---- TEST ACTIONS (id: 415) ----</h2>
          <br />
          <Actions
            showSubscribe
            showEdit
            showUnsubscribe
            showAdditionalInformation
            id={415}
          />
          <br />
          <h2>---- TEST MANAGE ----</h2>
          <br />
          <ManageRoutes />
          <h2>---- TEST VIEWER ----</h2>
          <br />
          <ViewerRoutes />
          <br />
        </>
      );
    }

    default: {
      return null;
    }
  }
};

export default Newsletter;
